export enum Language {
	EN = 'en',
	AR = 'ar'
}